<template>
  <div class="rmr-page-shell">
    <post-by-sources-hero
      :active-tab="page.activeTab"
      :dags="page.dags"
      @update:activeTab="setActiveTab"
    />

    <section class="rmr-page-shell__content">
      <global-watch-tab v-if="isGlobalWatch" />

      <div v-else class="pbs-legacy-tab">
        <url-batch />
      </div>
    </section>
  </div>
</template>

<script>
import { computed, onMounted, reactive } from "@vue/composition-api";

import PostBySourcesHero, {
  TAB_GLOBAL_WATCH,
  TAB_URL_BATCH,
} from "@/components/ai-factory/post-by-sources/PostBySourcesHero.vue";
import GlobalWatchTab from "@/components/ai-factory/post-by-sources/global-watch/GlobalWatchTab.vue";
import UrlBatch from "@/components/ai-factory/post-by-sources/Cards/UrlBatch.vue";

import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";
import { NEWS_RADAR_CRAWLER_DAGS } from "@/utils/constants";
import { saveRmraView } from "@/utils/rmr-analytics";

const TAB_PARAM = "tab";

export default {
  name: "GeneratePostBySources",
  components: {
    PostBySourcesHero,
    GlobalWatchTab,
    UrlBatch,
  },
  setup() {
    const { route, store } = useProxy();
    const { addQueryStringParam, getUrlValue } = useQueryString();

    const page = reactive({
      activeTab: TAB_GLOBAL_WATCH,
      dags: NEWS_RADAR_CRAWLER_DAGS,
      isInitialized: false,
    });

    // =>  COMPUTED
    const isGlobalWatch = computed(() => page.activeTab === TAB_GLOBAL_WATCH);

    // =>  METHODS
    const setActiveTab = (tab) => {
      page.activeTab = tab;

      // Only user changes are written to the URL — never the initial mount,
      // which would race with the filters restoring themselves from it.
      if (page.isInitialized) {
        addQueryStringParam({ param: TAB_PARAM, value: tab });
      }
    };

    // =>  HOOKS
    onMounted(async () => {
      const urlTab = getUrlValue({ param: TAB_PARAM });
      if (urlTab === TAB_URL_BATCH || urlTab === TAB_GLOBAL_WATCH) {
        page.activeTab = urlTab;
      }

      // A stale `true` left by another page would trigger a phantom fetch here:
      // `ApplyFilters` never resets the flag on mount.
      store.dispatch("common/updateApplyFilters", false);

      saveRmraView(route);
      page.isInitialized = true;
    });

    // =>  DATA
    return {
      isGlobalWatch,
      page,
      setActiveTab,
    };
  },
};
</script>

<style lang="scss" scoped>
// UrlBatch keeps its legacy Vuetify layout: give it the breathing room the
// page shell no longer provides.
.pbs-legacy-tab {
  padding-top: 16px;
}
</style>
